import React, { useEffect, useState } from "react";
import { Select, TextInput, Button, Label, Spinner } from "flowbite-react";
import showToast from "../CustomToast/toastHelper"; // Assuming you have a toast helper
import client from "../../api/client";
import { useNavigate } from "react-router-dom";


interface SecurityQuestionsProps {
    close: () => void,
    otp?: string,
    pin: string,
    confirmPin: string,
    closeAllModals: () => void
}
const SecurityQuestions = ({ close, otp, pin, confirmPin, closeAllModals }: SecurityQuestionsProps) => {
    const [questions, setQuestions] = useState(["", "", ""]);
    const [answers, setAnswers] = useState(["", "", ""]);
    const [questionsList, setQuestionsList] = useState<any[]>([])
    const [selectedQandA, setSelectedQandA] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const navigate = useNavigate();

    const fetchSecurityQuestions = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/security-questions/get');
            setQuestionsList(response.data.data);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    }

    const CompleteCreatePinProcess = async (questionsWithAnswers: any) => {
        setLoading(true)
        const payload = {
            otp,
            pin,
            confirmPin,
            securityQuestions: questionsWithAnswers
        }
        try {
            const response = await client.post('/subsidiary/dashboard/pin/create', payload);
            console.log(response.data.data);

            const message = response?.data?.message;
            showToast(message, "success")
            close()
            closeAllModals()
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
        finally {
            setLoading(false)
        }
    }

    const handleQuestionChange = (index: number, value: string) => {
        if (questions.includes(value)) {
            showToast("Please select a different question.", "error");
            return;
        }
        const newQuestions = [...questions];
        newQuestions[index] = value;
        setQuestions(newQuestions);

        console.log(questions);

    };

    const handleAnswerChange = (index: number, value: string) => {
        const newAnswers = [...answers];
        newAnswers[index] = value;
        setAnswers(newAnswers);
    };

    const handleSubmit = () => {
        if (questions.includes("") || answers.includes("")) {
            showToast("Please complete all fields.", "error");
            return;
        }
        let array: any[] = []

        questions.forEach((question, index) => {
            let obj = {
                questionId: Number(question),
                answer: answers[index]
            }
            array.push(obj)
        });

        CompleteCreatePinProcess(array)
        setTimeout(()=>{
            navigate(0)
        }, 4000)
    };

    useEffect(() => {
        const fetchData = async () => {
            await fetchSecurityQuestions()
        }
        fetchData()
    }, [])

    return (
        <div className="max-w-lg mx-auto bg-white p-6 ">
            <h2 className="text-xl font-semibold mb-4">Set Secret Questions</h2>
            <p className="text-sm text-gray-500 mb-4">Select 3 secret questions and provide your answers. These answers may be required for PIN reset or account recovery in the future.</p>

            {questions.map((question, index) => (
                <div key={index} className="mb-4">
                    <Label htmlFor={`question-${index}`} className="text-sm font-medium">Question {index + 1}</Label>
                    <Select
                        id={`question-${index}`}
                        value={question}
                        onChange={(e) => handleQuestionChange(index, e.target.value)}
                        className="w-full mt-1"
                    >
                        <option value="">Select a question</option>
                        {questionsList.map((q) => (
                            <option key={q} value={q.id} disabled={questions.includes(q.id)}>
                                {q.question}
                            </option>
                        ))}
                    </Select>

                    <TextInput
                        type="text"
                        placeholder="Enter your answer"
                        value={answers[index]}
                        onChange={(e) => handleAnswerChange(index, e.target.value)}
                        className="w-full mt-2"
                    />
                </div>
            ))}

            <div className="flex justify-center gap-4 w-full">
                <Button onClick={() => { close() }} className="bg-white text-black hover:text-white border-2 border-gray-300 hover:bg-gray-100 rounded-md">
                    Back
                </Button>
                <Button onClick={() => { handleSubmit() }} className="bg-custom-button-green text-white rounded-md hover:bg-green-600 transition">
                    {loading ? <Spinner size='sm' /> : 'Save'}
                </Button>
            </div>
        </div>
    );
};

export default SecurityQuestions;
